<template>
<div>
  <el-row>
    <el-col :sm="12" :lg="6">
      <el-result icon="warning" title="警告提示" subTitle="请根据提示进行操作">
      <template slot="extra">
        <el-button type="primary" size="medium"  @click="BackToAdminBoard">返回</el-button>
      </template>
    </el-result>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  methods: {
    BackToAdminBoard() {
      console.log('back to adminBoard')
      this.$router.push('/adminBoard')
    }
  }
}
</script>
